import React from 'react';
import PropTypes from 'prop-types';

import Block from 'hoc/Block';
import Button from 'components/Button';
import DocumentBlock from 'components/DocumentBlock';
import OnPageEditing from 'components/OnPageEditing';

import css from './DocumentListBlock.module.scss';

class DocumentListBlock extends React.PureComponent {
    static propTypes = {
        "heading": PropTypes.string,
        "readMoreLink": PropTypes.string,
        "readMoreText": PropTypes.string,
        "documents": PropTypes.arrayOf(PropTypes.shape({
            "title": PropTypes.string,
            "readMoreLink": PropTypes.string,
            "readMoreText": PropTypes.string,
            "thumbnailImage": PropTypes.string,
            "pdfLink": PropTypes.string,
            "webcastLink": PropTypes.string,
            "presentationLink": PropTypes.string,
            "pdfLinkText": PropTypes.string,
            "webcastLinkText": PropTypes.string,
            "presentationLinkText": PropTypes.string,
            "blockId": PropTypes.number,
            "contentType": PropTypes.string,
        })),
        "blockId": PropTypes.number,
        "contentType": PropTypes.string,
    }

    render() {
        const {
            readMoreLink,
            readMoreText,
            documents,
            blockId,
        } = this.props;

        return (
            <div className={css.block} data-block={blockId}>
                <OnPageEditing property="Documents">
                    {documents && documents.length > 0 && (
                        <ul className={css.documents}>
                            {documents.map(doc => (
                                <li key={doc.blockId}>
                                    <DocumentBlock {...doc} />
                                </li>
                            ))}
                        </ul>
                    )}
                </OnPageEditing>
                <OnPageEditing property="ReadMoreLink">
                    {readMoreLink && readMoreText && (
                        <p className={css.readmore}>
                            <Button
                                href={readMoreLink}
                                secondary
                            >{readMoreText}</Button>
                        </p>
                    )}
                </OnPageEditing>
            </div>
        );
    }
}

export default Block(DocumentListBlock);



// WEBPACK FOOTER //
// ./src/components/DocumentListBlock/DocumentListBlock.jsx